import { tomark } from "./metodosAdicionais"


export const useUnmark = () => {
    const unmark = (content) => {
        content.forEach(item => {
            if (item.innerHTML.includes('<mark style="background-color:Tomato; color: #FFF;">')) {
                const htmlUnselected = item.innerHTML.replaceAll(/<mark style="background-color:Tomato; color: #FFF;">(.*?)<\/mark>/g, '$1')
                item.innerHTML = item.innerHTML.replaceAll(item.innerHTML, htmlUnselected)
            }
        })
    }

    return { unmark }
}

export const useMarkText = (item, switchClicked) => tomark(item, switchClicked)